import { ListMasterPairings, ListMasterPairingsVariables } from './__generated__/ListMasterPairings'

import { gql } from 'apollo-boost'
import { useQuery } from '@apollo/react-hooks'

const QUERY = gql`
  query ListMasterPairings($input: ListMasterPairingInputV2!) {
    listMasterPairings: listMasterPairingsV2(input: $input) {
      nextCursor
      masterPairings {
        id
        boardId
        deviceId
        personFirstName
        personLastName
        accountId
        accountEmailAddress
        boardTitle
        createdAt
        dealId
        hubspotMessage
        hubspotUpdated
        manualReviewFlag
        manualReviewMessage
        memberIds
        memberEmailAddresses
        pairingDate
        personId
        plusApplicationDate
        plusRenewalDate
        plusRenewalFrequency
        synced
      }
    }
  }
`

export const useListMasterPairing = (variables: ListMasterPairingsVariables) =>
  useQuery<ListMasterPairings, ListMasterPairingsVariables>(QUERY, {
    variables
  })
